import { Type } from '@angular/core';
import { FacDesglosePagoComponent } from './fac-desglose-pago/fac-desglose-pago.component';

export const EXTENSION_REGISTRY: Record<string, Type<any>> = {
  'FAC_DESGLOSE_PAGO':  FacDesglosePagoComponent,
};

export function resolveExtension(cod: string): Type<any> | null {
  if (!cod) return null;
  return EXTENSION_REGISTRY[cod] ?? null;
}
